import blog1 from "../../../assets/images/blog/1.jpg";
import blog2 from "../../../assets/images/blog/2.jpg";
import blog3 from "../../../assets/images/blog/3.jpg";

const blogItems = [
    {
        imageSrc: blog1,
        title: "Want to know how Deep Learning works?",
        description: "fugiat! Quia, provident vitae! Magni tempora perferendis eum non provident."
    },
    {
        imageSrc: blog2,
        title: "How to become a skilled Developer",
        description: "Praesent sapien massa, convallis a pellentesque nec, egestas non nisi."
    },
    {
        imageSrc: blog3,
        title: "The best front hacking cheatsheets",
        description: "Proin eget tortor risus. Pellentesque in ipsum id orci porta dapibus."
    }
];

export default blogItems;